module.exports = __webpack_public_path__ + "static/media/SPEC_SEC-D_LQ080Y3LW01A_LD2022102A_220127.7fd74eb3.pdf";